<nz-space nzDirection="vertical" style="width: 100%">
  <nz-space-item>
    <button nz-button nzType="primary" nzBlock="true" (click)="allocateToDefaultBin()">
      {{'Allocate to default bin location' | locale}}
    </button>
  </nz-space-item>
  <nz-space-item>
    <input nz-input nzSize="large" [(ngModel)]="binSearchValue" [placeholder]="'Search for bin location' | locale"
      (ngModelChange)="searchForBin()" />
  </nz-space-item>
  <nz-space-item>
    <nz-table #table [nzData]="visibleBinLocations">
      <thead>
        <tr>
          <th>
            {{'Bin Location' | locale}}
          </th>
          <th>
            {{'Quantity' | locale}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bin of table.data">
          <td>
            <strong *ngIf="bin.IsDefault === 'Y'">
              <i nz-icon [nzType]="'check-square'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></i>
              {{bin.BinCode}}
            </strong>
            <span *ngIf="bin.IsDefault === 'N'">
              {{bin.BinCode}}
            </span>
          </td>
          <td>
            <nz-input-number [(ngModel)]="bin.SelectedQuantity" (change)="binQuantitySelected(bin);"></nz-input-number>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-space-item>
</nz-space>
